export class GameHudButtonGroup {
  constructor(scene, hud, { id, positiondata, viewport }) {
    this.scene = scene;
    this.hud = hud;
    this.groupAnchor = positiondata.anchor_group || { x: 0, y: 0 };
    this.screenAnchor = positiondata.anchor_screen || { x: 0, y: 0 };
    this.buttonAlign = 0.5;
    if (positiondata.hasOwnProperty('align_buttons')) {
      switch (positiondata.align_buttons) {
        case 'top':
          this.buttonAlign = 0;
          break;
        case 'bottom':
          this.buttonAlign = 1;
          break;
        case 'center':
          this.buttonAlign = 0.5;
          break;
        default:
          this.buttonAlign = positiondata.align_buttons;
          break;
      }
    }
    this.avoid = positiondata.avoid || [];
    this.buttonPadding = positiondata.hasOwnProperty('buttonPadding')
      ? positiondata.buttonPadding
      : 20;
    this.buttons = [];
    this.groupwidth = 0;
    this.groupx = 0;
    this.groupheight = 0;
    this.groupy = 0;
    this.viewport = viewport;
    this.id = id;
  }

  addIconGroup(value) {
    this._iconGroup = value;
    this.updatePosition(this.viewport);
  }

  addButtons(buttons) {
    buttons.forEach((button) => {
      this.addButton(button, false);
    });
  }

  addButton(button) {
    if (!this.hasButton(button)) {
      if (this.buttons.length > 0 && this.groupwidth > 0) {
        this.groupwidth += this.buttonPadding;
      }
      this.buttons.push({
        sprite: button,
        groupx: this.groupwidth + button.displayWidth * 0.5,
        groupy: button.displayHeight * 0.5,
      });
      this.groupwidth += button.displayWidth;
      this.groupheight = Math.max(this.groupheight, button.displayHeight);
      this.updatePosition(this.viewport);
    }
  }

  removeButtons(buttons) {
    buttons.forEach((button) => {
      this.removeButton(button, false);
    });
  }

  removeButton(button) {
    const index = this.getButtonIndex(button);
    if (index >= 0) {
      this.buttons.splice(index, 1);
      this.groupwidth -= button.width;
      this.updatePosition(this.viewport);
    }
  }

  clearButtons() {
    this.buttons = [];
    this.groupwidth = 0;
    this.groupheight = 0;
  }

  hasButton(button) {
    return this.getButtonIndex(button) >= 0;
  }

  getButtonIndex(button) {
    return this.buttons.findIndex((groupedbutton) => {
      return groupedbutton.sprite === button;
    });
  }

  updatePosition(viewport) {
    this.viewport = viewport || this.viewport;

    this.groupwidth = this._iconGroup ? this._iconGroup.displayWidth + this.buttonPadding : 0;
    this.groupheight = this._iconGroup ? this._iconGroup.displayHeight : 0;
    this.buttons.forEach((button) => {
      button.groupx = this.groupwidth + button.sprite.displayWidth * 0.5;
      button.groupy = button.sprite.displayHeight * 0.5;
      this.groupwidth +=
        button.sprite.displayWidth > 0 ? button.sprite.displayWidth + this.buttonPadding : 0;
      this.groupheight = Math.max(this.groupheight, button.sprite.displayHeight);
    });
    this.groupwidth -= this.buttonPadding;

    const vx = (viewport.width - viewport.padding * 2) * this.screenAnchor.x;
    const gx = this.groupwidth * this.groupAnchor.x;
    this.groupx = viewport.x + viewport.padding + (vx - gx);

    if (this._iconGroup) {
      this._iconGroup.x = this.groupx;
      this._iconGroup.y = this.groupy + this._iconGroup.displayHeight * 0.5;
      this._iconGroup.y +=
        this.groupheight * 0.5 - this._iconGroup.displayHeight * this.buttonAlign;
    }

    if (this.avoid.length > 0) {
      this.avoid.forEach((e) => {
        const bg = this.hud._buttonGroups[e];
        if (bg) {
          if (bg.groupx > this.groupx) {
            if (this.groupx + this.groupwidth + this.buttonPadding > bg.groupx) {
              this.groupx = Math.max(
                bg.groupx - this.buttonPadding - this.groupwidth,
                viewport.padding
              );
            }
          } else {
            if (this.groupx < bg.groupx + bg.groupwidth + this.buttonPadding) {
              this.groupx = Math.min(
                bg.groupx + bg.groupwidth + this.buttonPadding,
                viewport.width - viewport.padding - this.groupwidth
              );
            }
          }
        }
      });
    }

    const vy = (viewport.height - viewport.padding * 2) * this.screenAnchor.y;
    const gy = this.groupheight * this.groupAnchor.y;
    this.groupy = viewport.y + viewport.padding + (vy - gy);

    if (this.groupy + this.groupheight > viewport.bottomPadded) {
      this.groupy = viewport.bottomPadded - this.groupheight;
    }

    this.buttons.forEach((button) => {
      button.sprite.x = this.groupx + button.groupx;
      button.sprite.y = this.groupy + button.groupy;
      button.sprite.y +=
        this.groupheight * 0.5 -
        (button.sprite.displayHeight || button.sprite.height) * this.buttonAlign;
      if (button.sprite.onMoved) button.sprite.onMoved();
    });
  }

  destroy() {
    this.scene = null;
    this.groupAnchor = null;
    this.screenAnchor = null;
    this.buttonAlign = null;
    this.buttonPadding = null;
    this.buttons = null;
    this.groupwidth = null;
    this.groupheight = null;
    this.viewport = null;
  }
}
